import { render, staticRenderFns } from "./MtipocargaGrid.vue?vue&type=template&id=0ca0009e"
import script from "./MtipocargaGrid.vue?vue&type=script&lang=js"
export * from "./MtipocargaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports